import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import Sidebar from './Sidebar';
import { fetchOrders } from '../utils/apiService';
import mouse from '../assets/image/mouse.jpg';

const Order = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeOrder, setActiveOrder] = useState(null);
    const token = localStorage.getItem('token');

    useEffect(() => {
        const getOrders = async () => {
            if (!token) {
                setLoading(false);
                return;
            }
            try {
                const result = await fetchOrders(token);
                if (result && result.status && result.data) {
                    setOrders(result.data.data || []);
                }
            } catch (error) {
                console.error('Error fetching orders:', error);
            } finally {
                setLoading(false);
            }
        };

        getOrders();
    }, [token]);

    const toggleOrder = (index) => {
        setActiveOrder(activeOrder === index ? null : index);
    };
    return (
        <div className="wrapper position-relative">
            <Header />

            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1 className="title split-text effect-right">
                            Order History
                        </h1>
                    </div>
                </div>
            </div>

            <div className="main-content">
                <section className="section-team p-team tf-spacing-2">
                    <div className="tf-container">
                        <div className="row rg-30">
                            <div className="col-lg-4 col-md-4">
                                <Sidebar />
                            </div>

                            <div className="col-lg-8 col-md-8">
                                {loading ? (
                                    <div className="text-center">Loading orders...</div>
                                ) : orders.length === 0 ? (
                                    <div className="text-center">No orders found.</div>
                                ) : (
                                    orders.map((order, index) => (
                                        <div key={order.id} className={`order-card ${activeOrder === index ? 'active' : ''}`}>
                                            <div
                                                className="order-header"
                                                onClick={() => toggleOrder(index)}>
                                                <div className="order-shor-desc">
                                                    <h6>Order #{order.order_number}</h6>
                                                    <p>Placed on {new Date(order.created_at).toLocaleDateString()}</p>
                                                </div>

                                                <div className="order-price">
                                                    <strong>{order.currency || '$'} {order.total}</strong>
                                                    <span className="order-arrow"><i className="fa-solid fa-chevron-right"></i></span>
                                                </div>
                                            </div>

                                            <div className="order-details">
                                                {order.items && order.items.map((item) => (
                                                    <div key={item.id} className="order-product-row">
                                                        <img src={mouse} data-src={mouse} alt={item.product_name} className="ls-is-cached lazyloaded" />

                                                        <div className="order-product-info">
                                                            <h6>{item.product_name}</h6>
                                                            <p>Quantity: {item.quantity}</p>
                                                            <label>{order.currency || '$'} {item.price}</label>
                                                        </div>
                                                    </div>
                                                ))}
                                                <div className="order-price-summary">
                                                    <div><span>Subtotal</span><span>{order.currency || '$'} {order.subtotal}</span></div>
                                                    <div><span>Shipping</span><span>{order.currency || '$'} 0</span></div>
                                                    <div><span>Tax</span><span>{order.currency || '$'} {order.tax}</span></div>
                                                    <div className="total">
                                                        <span>Total</span>
                                                        <span>{order.currency || '$'} {order.total}</span>
                                                    </div>
                                                </div>
                                                <div className="order-address-section">
                                                    <h6>Billing Address</h6>
                                                    <p>
                                                        {order.first_name} {order.last_name}<br />
                                                        {order.address}, {order.city}, {order.state}, {order.country} - {order.postal_code}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>

                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default Order


